import { Clone, PartialUpdate, setByPath, getByPath, isObject, ObjectToDotNotation } from '@/utils'

function Factory(Template) {
  function Runner(data, options = {}) {
    let { strict = true, transform = {} } = options

    let template = Clone(Template, (key, value) => {
      if (value && value.prototype instanceof Factory) return null
      if (value instanceof Array && value.length === 1 && value[0].prototype instanceof Factory) return []
      return value
    })

    let dotnotationTemplate = Object.entries(ObjectToDotNotation(Template))

    let functions = dotnotationTemplate
      .filter(([key, value]) => typeof value === 'function' && !(value.prototype instanceof Factory))
      .forEach(([key, value]) => setByPath(key, value, template, data))

    if (!data || (isObject(data) && !Object.keys(data).length)) return template

    data = Clone(data)

    if (transform) Object.entries(transform).forEach(([key, value]) => setByPath(key, value, data))

    let submodels = dotnotationTemplate
      .filter(([key, value]) => {
        if (value && value.prototype instanceof Factory) return true
        if (value instanceof Array && value.length === 1 && value[0].prototype instanceof Factory) return true

        return false
      })
      .forEach(([key, value]) => {
        if (value instanceof Array)
          return setByPath(
            key,
            (getByPath(key, data) || []).map(entry => value[0](entry, { strict })),
            data,
          )
        return setByPath(key, value(getByPath(key, data), { strict: true }), data)
      })

    return PartialUpdate(template, data, { strict })
  }

  Object.setPrototypeOf(Runner.prototype, Factory.prototype)

  return Runner
}

export default Factory
